import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { ChatContext } from '../../../../coaching-base/chat-context.model';
import { ChatService } from '../../../../coaching-base/chat.service';
import { NextCoachingService } from '../../../../coaching-base/coaching.service';
import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { ChatRequest, SocketService } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

import { Load, loadResult } from './load.action';

export const loadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Load>>,
    _state: StateObservable<any>,
    deps: Dependencies,
): Observable<any> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TCD__LOAD),
        mergeMap((act: PayloadAction<ActionType, Load>) => {
            const coachingService =
                deps.injector?.get<NextCoachingService>(NextCoachingService);
            const service = deps.injector.get<ChatService>(ChatService);
            const socketService =
                deps.injector.get<SocketService>(SocketService);

            let ctx: ChatContext | null;
            try {
                ctx = JSON.parse(act.payload.opts.context);
            } catch {}

            return forkJoin([
                of(null).pipe(coachingService.retrieveLookupBox()),
                service.list(
                    ctx?.commitmentId,
                    act.payload.opts.chatId,
                    true,
                    true,
                ),
            ]).pipe(
                tap(([retBox, retChats]) => {
                    const next: ChatRequest = {
                        ...act.payload.opts,
                    };
                    if (retChats?.length > 0) {
                        next.chatId = retChats[0].chatId;
                    }
                    /* chat isn't retrieved/created when commitment-chat request failed */
                    if (retChats != null) {
                        void socketService.retrieveChat(next);
                    }
                }),
                map((ret) => {
                    return loadResult(
                        {
                            ...act.payload,
                            behaviours: ret[0].behaviours,
                            subBehaviours: ret[0].subBehaviours,
                            commitmentChat: ret[1]?.[0],
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(
                        loadResult(
                            {
                                ...act.payload,
                            },
                            act.storePath,
                        ),
                    );
                }),
            );
        }),
    );
